import * as Yup from "yup";

export default Yup.object().shape({
  email: Yup.string()
    .email("Utilisez un email valide")
    .required("ce champs est requis"),
});
